import React from 'react';
import { styled } from 'linaria/react';
import noiseTexture from 'assets/images/noise.png';

interface IPageBackgroundProps {
  startColor: string | null | undefined;
  baseColor: string;
  overlayHeightPx?: number;
  backgroundLayer?: React.ReactNode;
  foregroundLayer?: React.ReactNode;
  useRadialGradient?: boolean;
}

const StyledBackground = styled.div<{ startColor?: string | null; baseColor: string }>`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    background: url(${noiseTexture}),
      ${({ startColor, baseColor }) => `linear-gradient(180deg, ${startColor ?? baseColor} 0%, ${baseColor} 100%)`};
    background-repeat: repeat;
    background-size: auto;
    background-position: 0 0;
  }
`;

const StyledOverlay = styled.div<{
  startColor?: string | null;
  baseColor: string;
  overlayHeightPx?: number;
  useRadialGradient?: boolean;
}>`
  position: absolute;
  top: 0;
  left: calc(50% - 50vw);
  width: 100vw;
  height: ${({ overlayHeightPx }) => (overlayHeightPx ? `${overlayHeightPx - 40}px` : '0')};
  pointer-events: none;
  z-index: 0;
  display: ${({ overlayHeightPx }) => (overlayHeightPx ? 'block' : 'none')};
  background: url(${noiseTexture}),
    ${({ startColor, baseColor, useRadialGradient }) =>
      useRadialGradient
        ? `radial-gradient(ellipse at 50% 50%, ${startColor ?? baseColor} 0%, ${baseColor} 50%)`
        : `linear-gradient(180deg, ${startColor ?? baseColor} 0%, ${baseColor} 100%)`};
`;

const ContentWrap = styled.div`
  position: relative;
  z-index: 1;
`;

const PageBackground: React.FC<React.PropsWithChildren<IPageBackgroundProps>> = ({
  children,
  startColor,
  baseColor,
  overlayHeightPx,
  backgroundLayer,
  foregroundLayer,
  useRadialGradient,
}) => (
  <StyledBackground startColor={startColor ?? undefined} baseColor={baseColor}>
    {backgroundLayer}
    <StyledOverlay
      startColor={startColor ?? undefined}
      baseColor={baseColor}
      overlayHeightPx={overlayHeightPx}
      useRadialGradient={useRadialGradient}
    />
    {foregroundLayer}
    <ContentWrap>{children}</ContentWrap>
  </StyledBackground>
);

export default PageBackground;
